import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Input from '@cotyorg/ccx-atoms/Input';
import { getElapsedBarWidth } from './utils';

export const generateControlsBarClassNames = () => classNames(
  'cell auto',
  'flex-container align-middle',
  'video-player__controls-progress-bar',
  'video-player__controls-bar',
);

export const getInputProps = ({
  seeking,
  played,
}) => (seeking ? undefined : played);

// istanbul ignore next
const Seekbar = ({
  id,
  seeking,
  played,
  playerEl,
  setSeeking,
}) => (
  <div className={generateControlsBarClassNames()}>
    <Input
      type="range"
      min={0}
      max={1}
      step="any"
      extraClass="video-player__range flex-container"
      value={getInputProps({ seeking, played })}
      onMouseDown={() => setSeeking({ seeking: true, id })}
      onMouseUp={() => setSeeking({ seeking: false, id })}
      onChange={e => playerEl.seekTo(parseFloat(e.target.value))}
    />
    <span
      className="video-player__controls-bar--elapsed"
      style={{ width: `${getElapsedBarWidth(played)}` }}
    />
  </div>
);

Seekbar.propTypes = {
  id: PropTypes.string.isRequired,
  seeking: PropTypes.bool,
  played: PropTypes.number,
  playerEl: PropTypes.objectOf(PropTypes.any),
  setSeeking: PropTypes.func,
};

export default Seekbar;
